<template>
  <div class="ace-paper-cont clear-mrg">

    <!-- START: PAGE CONTENT -->

    <h2 class="title-lg text-upper padd-box">联系我们</h2>

    <div class="padd-box-xs">
      <header class="contact-head">
        <ul class="ace-social primary-social clear-list">
          <li><a><span class="ace-icon ace-icon-wechat"></span></a></li>
          <li><a><span class="ace-icon ace-icon-twitter"></span></a></li>
          <li><a><span class="ace-icon ace-icon-weibo"></span></a></li>
          <li><a><span class="ace-icon ace-icon-qq"></span></a></li>
        </ul>
<!--        <p class="title text-upper">fell free to contact me the core of your marketing
        </p> -->
      </header>
    </div>

    <div class="padd-box-sm">
      <form action="#" method="post" class="contact-form">

        <div class="form-group">
          <label class="form-label" for="author">姓名</label>
          <div class="form-item-wrap">
            <input id="author" class="form-item" type="text">
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="email">邮箱</label>
          <div class="form-item-wrap">
            <input id="email" class="form-item" type="email" required="required">
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="url">主题</label>
          <div class="form-item-wrap">
            <input id="url" class="form-item" type="url">
          </div>
        </div>

        <div class="form-group">
          <label class="form-label" for="comment">内容</label>
          <div class="form-item-wrap">
            <textarea id="comment" class="form-item"></textarea>
          </div>
        </div>

        <div class="form-submit form-item-wrap">
          <input class="btn btn-primary btn-lg" type="submit" value="确认">
        </div>
      </form>
    </div>

    <div id="map" data-latitude="50.84592" data-longitude="4.366859999999974"></div>

    <!-- END: PAGE CONTENT -->

  </div><!-- .ace-paper-cont -->
</template>

<script>
  export default {
    name: 'contact',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/contact.vue